import axios from 'axios';
import { formatApiError } from '@/lib/format-api-error';
import { isSenderDisabledMessage } from '@/lib/session-messages';

const WRONG_PIN_MESSAGE = 'Неверный пин-код';

export type PinAuthError = { kind: 'wrong-pin' } | { kind: 'sender-disabled' } | { kind: 'other'; message: string };

export function resolvePinAuthError(error: unknown): PinAuthError {
	const message = axios.isAxiosError(error) ? formatApiError(error.response?.data) : null;

	if (!message || message === WRONG_PIN_MESSAGE) {
		return { kind: 'wrong-pin' };
	}

	if (isSenderDisabledMessage(message)) {
		return { kind: 'sender-disabled' };
	}

	return { kind: 'other', message };
}
